<template>
  <v-card>
    <div class="pa-6">
      <div class="d-flex justify-end align-center pb-6">
        <v-spacer></v-spacer>
        <GradeReportExport :query="query" :exam="exam.name" />
      </div>
      <v-card class="mb-6">
        <GradeReportChart :data="reports" />
      </v-card>
      <v-card>
        <v-data-table
          item-key="id"
          :headers="headers"
          :loading="loading"
          :items="reports"
          hide-default-footer
          :items-per-page="-1"
          v-bind="this.$attrs"
          fixed-header
        >
        </v-data-table>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { ExamMark } from '../../plugins/api'
import GradeReportExport from './export/GradeReportExport.vue'
import GradeReportChart from './GradeReportChart.vue'

const originHeaders = [
  {
    text: 'Môn',
    value: 'subjectGroup',
    align: 'left',
    sortable: false
  },
  {
    text: 'Điểm cao nhất',
    value: 'highestMark',
    align: 'left',
    sortable: false
  },
  {
    text: 'SL HS đạt',
    value: 'highestMarkCount',
    align: 'left',
    sortable: false
  },
  {
    text: '≥9',
    value: '9To10',
    align: 'left',
    sortable: false
  },
  {
    text: '8.0 đến <9.0',
    value: '8To9',
    align: 'left',
    sortable: false
  },
  {
    text: '7.0 đến <8.0',
    value: '7To8',
    align: 'left',
    sortable: false
  },
  {
    text: '6.0 đến <7.0',
    value: '6To7',
    align: 'left',
    sortable: false
  },
  {
    text: '5.0 đến <6.0',
    value: '5To6',
    align: 'left',
    sortable: false
  },
  {
    text: '4.0 đến <5.0',
    value: '4To5',
    align: 'left',
    sortable: false
  },
  {
    text: '3.0 đến <4.0',
    value: '3To4',
    align: 'left',
    sortable: false
  },
  {
    text: '2.0 đến <3.0',
    value: '2To3',
    align: 'left',
    sortable: false
  },
  {
    text: '≥1.0 đến <2.0',
    value: '1To2',
    align: 'left',
    sortable: false
  },
  {
    text: `≤1.0`,
    value: '0To1',
    align: 'left',
    sortable: false
  },
  {
    text: 'Số HS KT',
    value: 'presentCount',
    align: 'left',
    sortable: false
  },

  {
    text: 'Số HS vắng KT',
    value: 'notPresentCount',
    align: 'left',
    sortable: false
  },
  {
    text: 'Điểm TB của HS',
    value: 'averageMark',
    align: 'left',
    sortable: false
  }
]

export default {
  components: { GradeReportChart, GradeReportExport },
  props: {
    room: Object,
    query: Object,
    exam: Object,
    subjects: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      subjectHeaders: [],
      reports: []
    }
  },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions('examMark', ['fetchMarks', 'countMarks']),
    ...mapActions('exam', ['updateExam']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      try {
        const reports = await ExamMark.getReportByGrade(this.query)
        this.reports = reports.reportData
        console.log(this.exam)
      } catch (error) {
        console.log(error)
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    }
  },
  watch: {
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  }
}
</script>
